var map = {
	"./img.svg": "HnV6",
	"./img10.svg": "EO2e",
	"./img11.svg": "Ct9L",
	"./img12.svg": "bvdA",
	"./img2.svg": "mLLK",
	"./img3.svg": "7eYy",
	"./img4.svg": "0RLc",
	"./img5.svg": "q4KM",
	"./img6.svg": "eHhE",
	"./img7.svg": "9Qaf",
	"./img8.svg": "udoG",
	"./img9.svg": "Npse"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 1